<h1 *ngIf="level === 'h1'" class="title">
  <span>{{ title }}</span>
  <ng-content select="[title]"></ng-content>
</h1>
<h2 *ngIf="level === 'h2'" class="title">{{ title }}</h2>
